<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav title="NUT" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="mt-20 nut-introduction-bg-image rounded-20 p-10">
					<div class="flex items-center justify-center py-20">
						<div class="w-150 h-150 rounded-full bg-primary"></div>
					</div>
					<div class="flex items-center justify-center">
						<span class="text-36 text-white">NUT Token</span>
					</div>
					<div class="mt-20 flex items-center justify-center">
						<span class="text-28 text-#ccc">{{$t('NUT.介绍.创新的Defi生态系统，多重分红机制')}}</span>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.代币信息')}}</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<span class="text-28 text-#ccc">{{$t('NUT.介绍.代币名称')}}</span>
						<span class="text-28 text-#ccc font-bold">{{$t('NUT.介绍.NUT 代币')}}</span>
					</div>
					<div class="mt-10 flex items-center justify-between">
						<span class="text-28 text-#ccc">{{$t('NUT.介绍.代币符号')}}</span>
						<span class="text-28 text-#ccc  font-bold">NUT</span>
					</div>
					<div class="mt-10 flex items-center justify-between">
						<span class="text-28 text-#ccc">{{$t('NUT.介绍.总供应量')}}</span>
						<span class="text-28 text-#ccc  font-bold">{{$t('NUT.介绍.一千万亿')}}</span>
					</div>
					<div class="mt-10 flex items-center justify-between">
						<span class="text-28 text-#ccc">{{$t('NUT.介绍.稳定比')}}</span>
						<span class="text-28 text-#ccc  font-bold">{{$t('NUT.介绍.美元兑日元')}}</span>
					</div>
					<div class="mt-10 flex items-center justify-between">
						<span class="text-28 text-#ccc">{{$t('NUT.介绍.奖励代币')}}</span>
						<span class="text-28 text-#ccc  font-bold">ROON</span>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.三大资金池')}}</span>
					</div>
					<div class="mt-20 h-140 p-20 flex items-center rounded-20" style="background-color: #3C0600;">
						<img class="w-76 h-76" src="@/assets/images/pages/nut-introduction/rsc.png" alt="" />
						<div class="ml-20">
							<div>
								<span class="text-28 text-#ccc">{{$t('NUT.介绍.燃烧池')}}</span>
							</div>
							<div>
								<span class="text-24 text-#ccc">{{$t('NUT.介绍.NUT/ROON 交易对，持续燃烧通缩')}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 h-140 p-20 flex items-center rounded-20" style="background-color: #00253C;">
						<img class="w-76 h-76" src="@/assets/images/pages/nut-introduction/wdc.png" alt="" />
						<div class="ml-20">
							<div>
								<span class="text-28 text-#ccc">{{$t('NUT.介绍.稳定池')}}</span>
							</div>
							<div>
								<span class="text-24 text-#ccc">{{$t('NUT.介绍.NUT/USDR 交易对，价格稳定支')}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 h-140 p-20 flex items-center rounded-20" style="background-color: #003007;">
						<img class="w-76 h-76" src="@/assets/images/pages/nut-introduction/tdc.png" alt="" />
						<div class="ml-20">
							<div>
								<span class="text-28 text-#ccc">{{$t('NUT.介绍.拖底池')}}</span>
							</div>
							<div>
								<span class="text-24 text-#ccc">{{$t('NUT.介绍.ROON 转账即交易，X314协议，隐藏性拖底')}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.交易手续费分配')}}（5%）</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/1.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.回流底池燃烧')}}</span>
						</div>
						<span class="text-28 text-#ccc">1%</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/2.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.回流ROON LP池')}}</span>
						</div>
						<span class="text-28 text-#ccc">1%</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/3.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.价格拖底')}}</span>
						</div>
						<span class="text-28 text-#ccc">1%</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/4.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.生态建设')}}</span>
						</div>
						<span class="text-28 text-#ccc">1%</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/5.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.持币分红')}}</span>
						</div>
						<span class="text-28 text-#ccc">0.5%</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/6.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.回购销毁')}}</span>
						</div>
						<span class="text-28 text-#ccc">0.5%</span>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.LP池机制')}}</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.LP每小时自动撤出0.25%')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.其中0.125%自动燃烧销毁')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.另外0.125%分红给LP提供者')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.1%手续费实时分红给LP用户')}}</span>
						</div>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.参与质押机制')}}</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.向合约地址打入ROON代币100')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.ROON=1份，可多次参与')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.全链上执行，透明可查')}}</span>
						</div>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #0F0F10;">
						<div class="px-10 flex items-center justify-between">
							<span class="text-28 text-white">{{$t('NUT.介绍.收益分配')}}</span>
						</div>
						<div class="mt-20 rounded-20 px-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.35%全网分红ROON")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.65%自动组LP锁定999年")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<span class=" text-24 text-primary">{{$t("NUT.介绍.65 ROON中:32.5买入NUT + 32.5 ROON组LP")}}</span>
							</div>
							
						</div>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.税收机制')}}</span>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #0F0F10;">
						<div class="px-10 flex items-center justify-between">
							<span class="text-28 text-white">{{$t('NUT.介绍.盈利税（20%）')}}</span>
						</div>
						<div class="mt-20 rounded-20 px-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.20%回购ROON分给参与者")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.其中10%分红给LP用户")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.5%的利润将分给NFT资产持有者")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.5%用于市值管理")}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #0F0F10;">
						<div class="px-10 flex items-center justify-between">
							<span class="text-28 text-white">{{$t('NUT.介绍.砸盘税 (最高25%)')}}</span>
						</div>
						<div class="mt-20 rounded-20 px-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.每天早上8点AVE价格为准")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.跌1%扣2%手续费")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.最高下跌12.5%时税率达25%")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.25% 回购ROON分给参与者")}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.持币分红')}}</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.0.5%手续费用于持币分红ROON')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.单地址持币>100,000 NUT可参与')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.前台手动领取，支付50% NUT价值')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.领取时50%销毁，50%到账')}}</span>
						</div>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.参与质押机制')}}</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.向合约地址打入ROON代币100')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.ROON=1份，可多次参与')}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<img class="w-30 h-30" src="@/assets/images/pages/nut-introduction/gx.png" alt="" />
							<span class="ml-10 text-28 text-#ccc">{{$t('NUT.介绍.全链上执行，透明可查')}}</span>
						</div>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #0F0F10;">
						<div class="px-10 flex items-center justify-between">
							<span class="text-28 text-white">{{$t('NUT.介绍.收益分配')}}</span>
						</div>
						<div class="mt-20 rounded-20 px-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.35%全网分红ROON")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.65%自动组LP锁定999年")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<span class=" text-24 text-primary">{{$t("NUT.介绍.65 ROON中:32.5买入NUT + 32.5 ROON组LP")}}</span>
							</div>
							
						</div>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div>
						<span class="text-36 text-white">{{$t('NUT.介绍.NFT分红机制')}}</span>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #0F0F10;">
						<div class="px-10 flex items-center justify-between">
							<span class="text-28 text-white">{{$t('NUT.介绍.节点NFT(50%)')}}</span>
						</div>
						<div class="mt-20 rounded-20 px-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.权重值分配分红")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.持币≥100.000 NUT激活")}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #0F0F10;">
						<div class="px-10 flex items-center justify-between">
							<span class="text-28 text-white">{{$t('NUT.介绍.白名单NFT(50%)')}}</span>
						</div>
						<div class="mt-20 rounded-20 px-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.加权平均分配分红")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.持币≥100.000 NUT激活")}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30 mr-10" style="background-color: #19191A;">
					<div class="px-10 flex items-center justify-between">
						<span class="text-28 text-white">{{$t('NUT.介绍.重要提示')}}</span>
					</div>
					<div class="mt-20 rounded-20 px-20">
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.所有盈利税和砸盘税分红ROON")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.领取时50%打入黑洞销毁，50%到用户钱包")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.全链上执行，透明可查")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("NUT.介绍.智能合约自动执行，无需人工干预")}}</span>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<menu-bar-nut activeMenu="nut-introduction"></menu-bar-nut>
		</template>
		<template v-slot:popup>
			
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBarNut from '@/components/menu-bar-nut/menu-bar-nut.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBarNut,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 2
				},
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
		},
		created() {
		},
		methods: {
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	
	.nut-introduction-bg-image {
		width: 690rem;
		height: 350rem;
		background-image: url("~@/assets/images/pages/nut-introduction/itembBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}
</style>